import type { PlayerMoveQuality } from '@acepoker/contract'
import { api } from './api'

export const getMovesQuality = async (
  playerId: string,
  sessionId?: string
): Promise<{
  items: PlayerMoveQuality[]
  total: number
}> => {
  const searchParams = new URLSearchParams()
  if (sessionId) {
    searchParams.append('sessionId', sessionId)
  }
  const searchString = searchParams.size !== 0 ? `?${searchParams.toString()}` : ''
  const endpoint = `/api/player/${playerId}/moves-quality${searchString}`
  return await api().get(endpoint).json()
}
